module.exports = __webpack_public_path__ + "static/media/14-5.e76ec598.mp3";